export const letterAvatar = (name, size) =>
    letterAvatarX({ name, size });

export const letterAvatarX = options => {
    let name = options.name || '';
    let size = options.size || 60;
    let color = options.color || false;
    let fullText = options.fullText || false;
    let singleLetterAvatar = options.singleLetterAvatar || false;

    const w = window;
    const d = document;

    let colours = [
        "#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#2980b9", "#8e44ad", "#2d8a62",
        "#f1c40f", "#e67e22", "#e74c3c", "#ecf0f1", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"
    ],
        initials, charIndex, colourIndex, canvas, context, dataURI;

    if (fullText) initials = name;
    else {
        const nameSplit = String(name).toUpperCase().split(' ');
        if (nameSplit.length === 1) {
            const lastChar = (nameSplit[0] && nameSplit[0].length > 0) ? nameSplit[0].charAt(nameSplit[0].length - 1) : '';
            if (singleLetterAvatar) initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
            else initials = nameSplit[0] ? nameSplit[0].charAt(0) + lastChar : '?';
        } else {
            if (singleLetterAvatar) initials = nameSplit[0].charAt(0);
            else initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
        }
    }

    if (w.devicePixelRatio) {
        size = (size * w.devicePixelRatio);
    }

    if (!color) {
        charIndex = (initials === '?' ? 72 : initials.charCodeAt(0)) - 64;
        colourIndex = charIndex % 20;
        color = colours[colourIndex - 1];
    }

    canvas = d.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    context = canvas.getContext("2d");

    context.fillStyle = color;
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.font = Math.round(canvas.width / 2) + "px Arial";
    context.textAlign = "center";
    context.fillStyle = "#FFF";
    context.fillText(initials, size / 2, size / 1.5);

    dataURI = canvas.toDataURL();
    canvas = null;

    return dataURI;
}